<script>
	import { cn } from "./cn.js";
	import { createEventDispatcher } from "svelte";

	// items: [{ key, label }], active: 현재 key. 클릭 시 change 이벤트(detail=key) dispatch.
	// 탭 상태 로직은 부모(Chat)가 소유 — 여긴 표현만.
	export let items = [];
	export let active = "";
	let className = "";
	export { className as class };

	const dispatch = createEventDispatcher();
</script>

<div
	class={cn(
		"tw-inline-flex tw-items-center tw-gap-1 tw-rounded-lg tw-bg-muted tw-p-1",
		className,
	)}
>
	{#each items as it (it.key)}
		<button
			type="button"
			class={cn(
				"tw-inline-flex tw-items-center tw-justify-center tw-rounded-md tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors tw-cursor-pointer",
				active === it.key
					? "tw-bg-background tw-text-foreground tw-shadow-sm"
					: "tw-text-muted-foreground hover:tw-text-foreground",
			)}
			on:click={() => dispatch("change", it.key)}
		>
			{it.label}
		</button>
	{/each}
</div>
